import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { PartnerLayout } from '@/layouts/PartnerLayout';
import { PartnerRoute } from '@/components/common/routes';

const PartnerDashboardPage = lazy(() =>
  import('@/pages/partner/DashboardPage').then((m) => ({ default: m.PartnerDashboardPage }))
);
const PartnerBookingsPage = lazy(() =>
  import('@/pages/partner/BookingsPage').then((m) => ({ default: m.PartnerBookingsPage }))
);
const PartnerSettingsPage = lazy(() =>
  import('@/pages/partner/PartnerSettingsPage').then((m) => ({ default: m.PartnerSettingsPage }))
);
const PartnerAccountSettingsPage = lazy(() =>
  import('@/pages/partner/AccountSettingsPage').then((m) => ({ default: m.PartnerAccountSettingsPage }))
);
const PartnerTeamPage = lazy(() => import('@/pages/partner/TeamPage').then((m) => ({ default: m.PartnerTeamPage })));
const PartnerWalletPage = lazy(() =>
  import('@/pages/partner/WalletPage').then((m) => ({ default: m.PartnerWalletPage }))
);
const PartnerLinksPage = lazy(() => import('@/pages/partner/LinksPage').then((m) => ({ default: m.PartnerLinksPage })));

export const partnerRoutes = (
  <Route element={<PartnerRoute />}>
    <Route element={<PartnerLayout />}>
      <Route path="/partner" element={<PartnerDashboardPage />} />
      <Route path="/partner/bookings" element={<PartnerBookingsPage />} />
      <Route path="/partner/team" element={<PartnerTeamPage />} />
      <Route path="/partner/wallet" element={<PartnerWalletPage />} />
      <Route path="/partner/links" element={<PartnerLinksPage />} />
      <Route path="/partner/account-settings" element={<PartnerAccountSettingsPage />} />
      <Route path="/partner/partner-settings" element={<PartnerSettingsPage />} />
    </Route>
  </Route>
);
